const CoverSection = ({ title, backgroundImage }) => {
  return (
    <section className="cover-section" style={{ backgroundImage: `url(${backgroundImage})` }}>
      <div className="cover-title">
        <h1>{title}</h1>
      </div>
    </section>
  );
};

export default CoverSection;
